/**
 * Admin Regions route segment, relative to the Admin domain. This package owns
 * every Regions URL: `regionsConfig` builds its route path, nav url and WS-login skip
 * path from these, and the page hands them to `@skynet/sky-region`'s components
 * via their `routes` prop, so the two can't drift apart.
 *
 * The URLs are literal: the app mounts the Admin domain at `adminRoutes.path`,
 * and the dashboard's admin feature drift test keeps every URL here resolving
 * to the route the app registers for it. This module has no imports, so the
 * boot-path feature config can read it without loading any UI.
 */
export const REGIONS_ROUTE_PATH = 'regions';

/** Admin Regions detail route, relative to the Admin domain; `:regionId` is the region's id. */
export const REGION_DETAIL_ROUTE_PATH = `${REGIONS_ROUTE_PATH}/:regionId`;

/** Absolute URL of the admin Regions list page. */
export const REGIONS_LIST_URL = '/admin/regions';

/** Absolute URL of a single region's detail page. */
export const getRegionPageUrl = (regionId: number | string): string =>
  `${REGIONS_LIST_URL}/${regionId}`;

/**
 * The URLs `@skynet/sky-region`'s components link and redirect to (its
 * `RegionRoutes`), built once from the constants above.
 */
export const regionRoutes = { listUrl: REGIONS_LIST_URL, getDetailUrl: getRegionPageUrl };
